import { mapActions, mapState } from "vuex";
import TenderFormLabel from "../comps/tender-form-item/form-label";
import formUtils from "./formUtils";
export const mixForFormItem = {
  components: {
    TenderFormLabel,
  },
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    attrs: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    let { options, form } = this;
    let param = formUtils.initFormParam(options);
    options.Required = options.Required !== false;
    options.Disabled = options.Disabled === true;
    options.Visible = options.Visible !== false;
    return {
      validTv: null,
      index: 0,
      param: param,
      rules: formUtils.initFormRules(options, this, param),
    };
  },
  computed: {
    ...mapState(["form", "selections"]),
    required() {
      return this.options.Required;
    },
  },
  methods: {
    setFormItemValue(value) {
      this.$store.commit("setFormItemValue", { key: this.options.Key, value: value });
    },
    doValidate() {
      // 表单验证
      clearTimeout(this.validTv);
      this.validTv = setTimeout(() => {
        this.setValidatorCount();
      }, 500);
    },
    ...mapActions([
      "setValidatorCount", "setCustomValidate", "setFormItemWithCustom", 
      "houseRules", "houseHooks", "trafficRules", "trafficHooks", "ajaxAutoItems"
    ]),
  },
};
